export enum RouteActions {
  Next = 'Next',
  Previous = 'Previous',
  Reset = 'Reset',
}

export enum MeridiemIndicator {
  AM = 'AM',
  PM = 'PM',
}
